import { baseUrl } from '../network'  

export const editProfileUrl = baseUrl + 'api/edit/profile'
export const deleteProfileDocumentUrl = (documentId: number) => `${baseUrl}api/user/files/${documentId}`
export const uploadProfileDocumentUrl = baseUrl + 'api/user/files'
export const getProfileDocumentsUrl = baseUrl + 'api/user/files'
export const getUserNotificationsUrl = (isRead?: boolean) => baseUrl + `api/profile/notifications?is_read=${isRead}`
export const markUserNotificationAsReadUrl = (notificationId: number) => baseUrl + `api/profile/notifications/${notificationId}`
export const deleteUserNotificationUrl = (notificationId: number) => baseUrl + `api/profile/notifications/${notificationId}`